<template>
  <div class="AboutUs">关于我们</div>
</template>

<script>
export default {};
</script>

<style>
</style>